import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import {AccountService} from "../../services";
import {Module} from "../models/module";
import {ModuleRolePermissionList} from "../models/moduleRolePermissionList";
import {Permission} from "../models/permission";
import {Role} from "../models/role";
import {map} from "rxjs/operators";
import {TokenService} from "../../services/token.service";

@Injectable({ providedIn: 'root' })
export class ModuleRolePermissionService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private tokenService: TokenService
    ) {

    }

    getAll() {
        return this.http.get<ModuleRolePermissionList>(`${environment.apiEndpoint}/v1/security/module-role-permissions`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.tokenService.userValue.token,
            }),
        });
    }

    getByModule(module: Module) {
        let filtersString = 'filters[module]=' + module.id;

        return this.http.get<ModuleRolePermissionList>(`${environment.apiEndpoint}/v1/security/module-role-permissions?` + filtersString, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.tokenService.userValue.token,
            }),
        });
    }

    getByRole(role: string) {
        let filtersString = 'filters[role_name]=' + role;

        return this.http.get<ModuleRolePermissionList>(`${environment.apiEndpoint}/v1/security/module-role-permissions?` + filtersString, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.tokenService.userValue.token,
            }),
        });
    }

    changePermissions(module: Module, role: Role, permission: Permission, allow: boolean) {
        let params = {
            "allow": allow,
            "module": module.id,
            "role": role.id,
            "permission": permission.id
        };

        return this.http.post(`${environment.apiEndpoint}/v1/security/module-role-permissions`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.tokenService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }
}
